import {Flex, Input, Modal, Space, Typography} from "antd";
import React, {useEffect} from "react";
import '@mdxeditor/editor/style.css';
import {
    MDXEditor
} from '@mdxeditor/editor';
import {TagFlow} from "../../components/TagFlow";
import {Tag} from "../../feature/project/fields";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {useParams} from "react-router-dom";
import {Status} from "../../feature/project/status";
import {fetchTags} from "../../feature/project/projectsSlice";
import {Act} from "../../feature/project/story";
import {addActTag, removeActTag} from "../../feature/project/actSlice";

export interface ChapterProps {
    act: Act,
    visible: boolean,
    onCancel: () => void,
    onSave: (act: Act) => void,
}

export const AddActModal = (props: ChapterProps) => {
    const dispatch = useAppDispatch();
    const {projectId} = useParams();
    const allTags = useAppSelector(state => state.projects.tags)
    const status = useAppSelector(state => state.components.status)
    const [hasChanges, setHasChanges] = React.useState(false)
    const [title, setTitle] = React.useState(props.act.title)
    const [description, setDescription] = React.useState(props.act.description)
   const [tags, setTags] = React.useState<Array<Tag>>(props.act.tags || [])

    useEffect(() => {
        setTitle(props.act.title)
        setDescription(props.act.description || '')
        setTags(props.act.tags || [])
    }, [props.visible, props.act, props.act.tags])

    useEffect(() => {
        setHasChanges(title !== props.act.title || description !== props.act.description)
    }, [title, description])

    useEffect(() => {
        if (status == Status.Idle && projectId && props.visible) {
            if (props.act.id) {
                dispatch(fetchTags({projectId: parseInt(projectId)}))
            }
        }
    }, [status, dispatch])

    return (
        <Modal
            maskClosable={false}
            open={props.visible}
            destroyOnClose={true}
            title={props.act.id ? 'Act Settings' : `Add Act`}
            okText={'Save'}
            okButtonProps={{disabled: !hasChanges}}
            onCancel={() => props.onCancel()}
            onOk={() => props.onSave({
                id: props.act.id,
                title: title || "",
                description: description || "",
                tags: tags
            })
            }
            width={600}
        >
            <Flex gap={16}>
                <Space direction={'vertical'} style={{width: '100%', maxHeight: 400, overflowY: 'auto', scrollbarWidth: "none"}} size={16}>
                    <div>
                        <Typography style={{fontWeight: 700}}>Title</Typography>
                        <Input value={title} onChange={(e) => setTitle(e.target.value)}/>
                    </div>
                    <div>
                        <Typography style={{fontWeight: 700}}>Content</Typography>
                        <MDXEditor
                            className={"markdown-text"}
                            markdown={description || ""}
                            onChange={(e) => setDescription(e)}
                            plugins={[]}
                        />
                    </div>
                    <div>
                        <Typography style={{fontWeight: 700}}>Tags</Typography>
                        <TagFlow allTags={allTags}
                                 tags={tags}
                                 onTagAdded={(tag) => {
                                     setTags([...tags, tag])
                                     if (props.act.id && projectId) {
                                         dispatch(addActTag({
                                             projectId: parseInt(projectId),
                                             actId: props.act.id,
                                             tag: {title: tag.title}
                                         }))
                                     }
                                 }}
                                 onTagDeleted={(tag) => {
                                     if (tag.id && props.act.id && projectId) {
                                         dispatch(removeActTag({
                                             projectId: parseInt(projectId),
                                             actId: props.act.id,
                                             tagId: tag.id
                                         }))
                                     }
                                 }}
                        />
                    </div>
                </Space>
            </Flex>
        </Modal>
    );
}